package com.example.readingnotes.domain.model

data class AuthState(
    val isAdmin: Boolean,
    val user: User? = null,
    val totpVerified: Boolean = false,
)
